import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { useProjectStore } from '@/stores/project'

/**
 * Version guard that blocks navigation to project pages when version mismatch exists.
 * For summary page: allows only when in stored results mode
 * For other pages: always blocks when version mismatch exists
 * Redirects to: /project/update
 */
export const versionGuard = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext
): Promise<void> => {
  const projectStore = useProjectStore()
  const enrichedUpdates = projectStore.getEnrichedUpdates
  const highestUpdateLevel = projectStore.getHighestUpdateLevel

  // No version mismatch - allow navigation
  if (!enrichedUpdates?.length || !highestUpdateLevel) {
    return next()
  }

  // Summary page is allowed only when viewing stored results
  if (to.name === 'summary-project-view' && projectStore.useStoredResults) {
    return next()
  }

  // Version mismatch exists - redirect to update page
  return next({ name: 'version-update-view' })
}
